
// App.js
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React, { Suspense, useState } from 'react';
import DefaultLayout from './component/layout/DefaultLayout';
import Login from './views/pages/Login';
import StudentRegistration from './views/pages/StudentRegistration';
import ProtectedRoute from './Authentication/ProtectedRoute';
import { AuthProvider } from './Authentication/AuthProvider';
import NotAuthorized from './views/pages/NotAuthorized'; // Import the NotAuthorized component
import ForgotPassword from './views/pages/ForgotPassword';
import ResetPassword from './views/pages/ResetPassword';

const App = () => {

  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<ResetPassword />} />
            <Route path="/register" element={<StudentRegistration />} />
            <Route path="/not-authorized" element={<NotAuthorized />} /> {/* Route for NotAuthorized component */}
            {/* Add other routes with ProtectedRoute as needed */}
            <Route path="*" element={<ProtectedRoute element={<DefaultLayout />} />} />
            {/* Add more routes with ProtectedRoute as needed */}
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  )

};

export default App;
